import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getTestId } from '../../utils/testId.js';
import { idFromName, computeId } from '../../utils/html.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "checkbox": "web_ui__Checkbox__checkbox",
  "button": "web_ui__Checkbox__button",
  "text-center": "web_ui__Checkbox__text-center",
  "button-right": "web_ui__Checkbox__button-right",
  "button-left": "web_ui__Checkbox__button-left",
  "experimental-checkbox-background-color": "web_ui__Checkbox__experimental-checkbox-background-color",
  "inverse": "web_ui__Checkbox__inverse",
  "label": "web_ui__Checkbox__label"
};

var cssClasses = classNames.bind(styles);
var CheckboxBase = function CheckboxBase(props) {
  var name = props.name,
    idProp = props.id,
    value = props.value,
    _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'right' : _props$labelPosition,
    _props$labelAlignment = props.labelAlignment,
    labelAlignment = _props$labelAlignment === void 0 ? 'top' : _props$labelAlignment,
    checked = props.checked,
    _props$defaultChecked = props.defaultChecked,
    defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    disabled = props.disabled,
    inverse = props.inverse,
    tabIndex = props.tabIndex,
    onClick = props.onClick,
    onBlur = props.onBlur,
    aria = props.aria,
    testId = props.testId,
    experimentalApplyBackground = props.experimentalApplyBackground,
    forwardedRef = props.forwardedRef;
  var onChange = 'onChange' in props ? props.onChange : undefined;
  var baseId = idFromName(name);
  var computedId = computeId(idProp, baseId);
  var labelStyles = cssClasses(styles.checkbox, {
    inverse: inverse,
    'experimental-checkbox-background-color': experimentalApplyBackground
  });
  var buttonStyles = cssClasses(styles.button, {
    'button-left': labelPosition === 'right',
    'button-right': labelPosition === 'left',
    'text-top': labelAlignment === 'top',
    'text-center': labelAlignment === 'center'
  });
  return /*#__PURE__*/jsxs("label", {
    htmlFor: computedId,
    "data-testid": testId,
    className: labelStyles,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({
      type: "checkbox",
      id: computedId,
      name: name,
      value: value || '1',
      checked: checked
    }, defaultChecked && {
      defaultChecked: defaultChecked
    }), {}, {
      disabled: disabled,
      onClick: onClick,
      onBlur: onBlur,
      onChange: onChange,
      tabIndex: tabIndex,
      "data-testid": getTestId(testId, 'input'),
      ref: forwardedRef
    }, aria)), /*#__PURE__*/jsx("span", {
      className: buttonStyles,
      children: text ? /*#__PURE__*/jsx("span", {
        className: styles.label,
        "data-testid": getTestId(testId, 'text'),
        children: text
      }) : null
    })]
  });
};
var CheckboxWithForwardedRefBase = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(CheckboxBase, _objectSpread({
    forwardedRef: ref
  }, props));
});
CheckboxWithForwardedRefBase.displayName = CheckboxBase.name;

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var CheckboxWithForwardedRef = CheckboxWithForwardedRefBase;

export { CheckboxWithForwardedRef, CheckboxWithForwardedRef as default };
//# sourceMappingURL=Checkbox.js.map
